<template>
  <div class="x-upload cube-input">
    <input class="x-upload-input" ref="fileInput" type="file" :accept="accept" :multiple="uploadNumber > 1 ? true : false" @change="handleChange" >
    <input 
      v-if="renderSence === 'edit' && !readOnly && uploadList.length === 0" 
      class="cube-input-field cube-input-field--placeholder" 
      @click="handleClick"
      readonly
      :value="placeholder"
    >
    <x-upload-list 
      v-else 
      :uploadList="uploadList"
      :renderSence="renderSence"
      :readOnly="readOnly"
      v-bind="$attrs"
      @remove="handleRemove"
      @download="handleDownload"
      @cancalUploadFile="cancalUploadFile"
    ></x-upload-list>
  </div>
</template>

<script>
import XUploadList from './x-upload-list/x-upload-list'
import { openCameraUpload } from '@/vender/third-sdk/third-function/get-camera.js'
import { isOnlyWechat } from '@/lib/ui/utils/platform.util.js'
import { wxSdkInit } from '@/vender/third-sdk/wx-sdk.js'

const UUIDUtil = {
  guid: function guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }

    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
  }
}

export default {
  name: 'XUpload',
  components: {
    XUploadList
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    click: {
      type: Boolean,
      default: true
    },
    uploadNumber: {
      type: Number,
      default: 1
    },
    uploadLimit: {
      type: Number,
      default: 100
    },
    renderSence: {
      type: String,
      default: 'edit',
      validator(value) {
        return ['edit', 'read'].indexOf(value) !== -1
      }
    },
    uploadType: {
      type: [String, Array],
      default() {
        return ['img']
      }
    },
    beforeUpload: Function,
    beforeRemove: Function,
    postUpload: {
      type: Function,
      requried: true
    },
    removeUpload: {
      type: Function,
      requried: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadList: []
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal instanceof Array) {
          this.uploadList = newVal
        }
      },
      immediate: true
    }
  },
  computed: {
    placeholder() {
      return `可上传${ this.uploadNumber === Infinity ? '多' : this.uploadNumber }个文件，单个文件大小不超过${ this.uploadLimit } M`
    },
    accept() {
      if (this.uploadType instanceof Array) {
        return this.uploadType.reduce((prev, type) => {
          if (type === 'img') {
            prev.push('image/jpeg', 'image/jpg', 'image/png', 'image/gif')
          } else if (type === 'word') {
            prev.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword')
          } else if (type === 'excel') {
            prev.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel')
          } else if (type === 'mp4') {
            prev.push('audio/mpeg', 'audio/mp4, video/mp4', 'video/quicktime')
          } else if (type === 'zip') {
            prev.push('application/x-zip-compressed','application/zip', '.rar', '.jar', 'application/octet-stream', '.7z', 'application/x-gzip')
          } else if (type === 'pdf') {
            prev.push('application/pdf')
          }
          return prev
        }, []).toString()
      } else {
        return this.uploadType
      }
    },
    isOnlyImage() {
      return this.uploadType instanceof Array && this.uploadType.length === 1 && this.uploadType[0] === 'img'
    }
  },
  methods: {
    emitFormValue(id) {
      this.uploadList = this.uploadList.filter(item => !(item.uuid && item.uuid === id))
      if (this.uploadList.every(item => item.status === 'completed')) {
        this.$emit('input', this.$lodash.cloneDeep(this.uploadList))
      }
    },
    handleClick() {
      if (this.click) {
        this.chooseFile()
      }
    },
    handleClickUpload() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        wxSdkInit('ocr')
        this.$bus.$on(`getOcrInit`, () => {
          setTimeout(() => {
            openCameraUpload().then((data) => {
              this.handleUpload(data)
            })
          }, 150);
          this.$bus.$off('getOcrInit')
        })
        // this.$refs.fileInput && this.$refs.fileInput.click()
      } else {
        openCameraUpload().then((data) => {
          this.handleUpload(data)
        })
      }
    },
    chooseFile() {
      if (this.uploadList.length < this.uploadNumber && this.renderSence !== 'read') {
        if (isOnlyWechat() && this.isOnlyImage) {
          this.handleClickUpload()
        } else {
          this.$refs.fileInput && this.$refs.fileInput.click()
        }
      }
    },
    handleChange(event) {
      const fileList = Array.from(event.target.files)
      console.log(fileList)
      if (!this.validateFileNumber(fileList)) this.$message({ type: 'warning', message: '所选文件超出数量限制' })
      else if (!this.validateFileType(fileList)) this.$message({ type: 'warning', message: '文件格式不正确' })
      else if (!this.validateFileSize(fileList)) this.$message({ type: 'warning', message: '文件太大，请重新上传' })
      else {
        fileList.forEach((file, index) => {
          let result = this.beforeUpload && this.beforeUpload(file, fileList)
          if (result instanceof Promise) {
            result.then(() => {
              this.handleUpload(file)
            })
          } else {
            this.handleUpload(file)
          }
        })
      }
      this.$refs.fileInput.value = ""
    },
    getLocalFileSrc(file) {
      return window.URL.createObjectURL(file)
    },
    getLocalFileSizeStr(file) {
      if (file.size > 1024 * 1024 * 1024) {
        return (file.size / 1024 / 1024 / 1024).toFixed(1) + ' GB' 
      } else if (file.size > 1024 * 1024) {
        return (file.size / 1024 / 1024).toFixed(1) + ' MB' 
      } else if (file.size > 1024) {
        return (file.size / 1024 ).toFixed(1) + ' KB' 
      } else {
        return file.size + ' B' 
      }
    },
    getLocalFileType(file) {
      const FILE_MAP = {
        'image/jpeg': 'image', 
        'image/png': 'image', 
        'image/gif': 'image',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word', 
        'application/msword': 'word',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
        'application/vnd.ms-excel': 'excel',
        'application/pdf': 'pdf',
        'audio/mpeg': 'video', 
        'audio/mp4, video/mp4': 'video', 
        'video/quicktime': 'video',
        'application/x-zip-compressed': 'compressed',
        'application/zip': 'compressed', 
        'jar': 'compressed', 
        'application/octet-stream': 'compressed',
        'rar': 'compressed',
        '7z': 'compressed', 
        'application/x-gzip': 'compressed',
        'unknown': 'unknown'
      }
      return FILE_MAP[file.type] || FILE_MAP[this.getFileSuppix(file.name)] || 'unknown'
    },

    getFileSuppix(filename) {
      const splitList = filename.split('.')
      if (splitList.length < 1) {
        return 'unknown'
      }
      return splitList[splitList.length - 1].toLowerCase()
    },
    getImgSize(base64url) {
      // 获取base64图片大小，返回KB数字
      var str = base64url.replace('data:image/jpeg;base64,', '') // 这里根据自己上传图片的格式进行相应修改
      var strLength = str.length
      var fileLength = parseInt(strLength - (strLength / 8) * 2)
      // 由字节转换为KB
      var size = ""
      size = (fileLength / 1024).toFixed(2)
      return parseInt(size)
    },
    handleUpload(file) {
      let _file
      if (isOnlyWechat() && this.isOnlyImage) {
        const size = this.getImgSize(file)
        if (size > 4 * 1024) {
          this.$message({ type: 'warning', message: '文件太大，请重新上传' })
          return
        }
        _file = {
          fileName: '',
          fileType: 'image',
          fileSize: '',
          fileSizeStr: '',
          creatorName: '',
          creationDate: '',
          url: '',
          src: file,
          id: Date.now(),
          tenantId: '',
          status: 'pending'
        }
      } else {
        _file = {
          fileName: file.name,
          fileType: this.getLocalFileType(file),
          fileSize: file.size,
          fileSizeStr: this.getLocalFileSizeStr(file),
          creatorName: '',
          creationDate: '',
          url: '',
          src: this.getLocalFileSrc(file),
          id: Date.now(),
          tenantId: '',
          status: 'pending'
        }
      }
      _file.uuid = UUIDUtil.guid()
      file.uuid = _file.uuid
      this.uploadList.push(_file)
      this.postUpload(file).then(data => {
        Object.assign(_file, {
          ...data,
          status: 'completed'
        })
        console.log(this.uploadList)
        if (this.uploadList.every(item => item.status === 'completed')) {
          this.$emit('input', this.$lodash.cloneDeep(this.uploadList))
        }
      }, (err) => {
        console.error(err)
        if (err.message === 'hide-message') {
        } else {
          this.uploadList.splice(this.uploadList.indexOf(_file), 1)
        }
      })
    },
    handleRemove(file) {
      let result = this.beforeRemove && this.beforeRemove(file)
      if (result instanceof Promise) {
        result.then(() => {
          this.handleDelete(file)
        })
      } else {
        this.handleDelete(file)
      }
    },
    handleDelete(file) {
      file.status === 'pending'
      this.removeUpload(file).then(data => {
        this.uploadList.splice(this.uploadList.indexOf(file), 1)
        this.$emit('input', this.$lodash.cloneDeep(this.uploadList))
        console.log(this.uploadList)
      }, (err) => {
        console.error(err)
      })
    },
    handleDownload(file) {
      this.$emit('download', file)
    },
    validateFileNumber(fileList) {
      return (this.uploadList.length + fileList.length) <= this.uploadNumber
    },
    validateFileType(fileList) {
      return this.accept
       ? fileList.every(file => this.accept.indexOf(file.type) !== -1)
       : true
    },
    validateFileSize(fileList) {
      return fileList.every(file => file.size <= (this.uploadLimit * 1024 * 1024))
    },
    cancalUploadFile(data) {
      this.$emit('cancal-upload', data)
    }
  }
}
</script>

<style lang="scss">
.x-upload {
  .x-upload-input {
    display: none;
  }
  .cube-input-field {
    cursor: pointer;
  }
}
</style>